import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import {Http, Headers, RequestOptions } from '@angular/http';
import { HTTP } from '@ionic-native/http';
import 'rxjs/add/observable/fromPromise';
import { TranslateService } from '@ngx-translate/core';
import { AlertController,LoadingController,ToastController, } from 'ionic-angular';
import { Geolocation } from '@ionic-native/geolocation';
import { Observable } from 'rxjs';
import * as XLSX from 'xlsx';
@Injectable()
export class HkApiproviderProvider {

/*   Thanks for Purchase */
/*   Buy App From Envato Get Lifetime Updates*/
/*   Tech Support : Whatsapp +917696355852, Skype : blackhat.ajay */
  /*******************************
 * 
 *  Developer : Ajay randhawa
 *  Email : ajayrandhawartg@gmail.com
 *  
 *  Please don't share this script on nulled websites 
 *  Buy from Envato & appreciate Developer
 * 
 * ******************************/


 /*******  CHANGE URL HERE ***************/
  static location = {
    latitude:'',
    longitude:''
  }
  url = 'https://sr.we-count.info';
  //url = 'https://demo.springrevolutions.com';
  //url = 'http://local.blackcampaign.info';
  static token = '5a3bb10e40903af3b9eb0b99cfef11d0f9c946f34c69d680647564bdf0172342';
 /****************************************/
  baseUrl = this.url + '/app/';
  data: any;
  caseimagebaseurl = this.url + '/admin/images/case/';
  soldierimagebaseurl = this.url + '/admin/images/soldier/';
  imageCriminalbaseurl = this.url + '/admin/images/criminal/';
  imageNotibaseurl = this.url + '/admin/images/notification/';
  bannerbaseurl = this.url + '/admin/images/banner/';
  recipesbaseurl = this.url + '/admin/recipes/';
  version = '1.2';
  /*********************************************** */
  alert_message:any = [];
  constructor(public http: Http, public httpnative:HTTP,private translate: TranslateService, public alertCtrl: AlertController, public toastCtrl : ToastController, public loadingCtrl : LoadingController,private geolocation: Geolocation) {
  }

  postData(credentials, type){
    return new Promise((resolve, reject) =>{
      let headers = new Headers();
      this.http.post(this.baseUrl+type, JSON.stringify(credentials), {headers: headers}).
      subscribe(res =>{
        resolve(res.json());
      }, (err) =>{
        reject(err);
      });
    });
  }
  
  postGetSMSToken(){
    return new Promise((resolve, reject) =>{
      let username = 'mytelb2b';
      let password = '5c24b3ef-bd07-4c3c-b456-6787e8b5e80f';
      const encoded = btoa(username + ":" + password);
      let details = {
        grant_type: "client_credentials"
      }
      let url = 'https://mpg-ids.mytel.com.mm/auth/realms/eis/protocol/openid-connect/token';
      this.httpnative.post(url,  details, {'Authorization': `Basic ${encoded}`, 'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
      .then( res => resolve(JSON.parse(res.data)))

     });
  }


postSMSSend(credentials, token){
  return new Promise((resolve, reject) =>{
    let headers = new Headers();
    headers.append('Authorization',`Bearer ${token}`);
    headers.append('Content-Type', 'application/json');
    headers.append('Accept', 'application/json');

    let url = 'https://mytelapigw.mytel.com.mm/msg-service/v1.3/smsmt/sent';
    this.http.post(url, JSON.stringify(credentials), {headers: headers}).
    subscribe(res =>{
      resolve(res.json());
    }, (err) =>{
      reject(err);
    });
  });
}

  postAyaPayHeader(credentials){
    return new Promise((resolve, reject) =>{
      let username = 'w5sfIq2NHJwak5Lq9xVclhHQ2ssa';
      let password = 'inu80WfaiaYDn00TTdaZXmJzjJ4a';
      const encoded = btoa(username + ":" + password);
       let url = 'https://api.ayapay.com/token';
       // let url = 'https://opensandbox.ayainnovation.com/token';
       this.httpnative.post(url,  credentials, {'Authorization': `Basic ${encoded}`, 'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
       .then( res => resolve(JSON.parse(res.data)))
    //   .catch( err => reject(JSON.parse(err)));
      });
  }


  postAyaPayLogin(credentials, token){
    return new Promise((resolve, reject) =>{
        let url = 'https://api.ayapay.com/merchant/1.0.0/thirdparty/merchant/login';
       //let url = 'https://opensandbox.ayainnovation.com/merchant/1.0.0/thirdparty/merchant/login';
       this.httpnative.post(url, credentials, {'Token': `Bearer ${token}`,'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
       .then( res => resolve(JSON.parse(res.data)))
      });
  }

  postAyaPayRequestPayment(credentials, token,authorization){
    return new Promise((resolve, reject) =>{
       let url = 'https://api.ayapay.com/merchant/1.0.0/thirdparty/merchant/requestPushPayment';
      // let url = 'https://opensandbox.ayainnovation.com/merchant/1.0.0/thirdparty/merchant/requestPushPayment';
       this.httpnative.post(url, credentials, {'Token': `Bearer ${token}`,'Authorization': `Bearer ${authorization}`,'Content-Type': 'application/x-www-form-urlencoded','Accept': 'application/json' })
       .then( res => {
        resolve(JSON.parse(res.data));
       });
    });
  }

  postKBZPrecreate(credentials){
    return new Promise((resolve, reject) =>{
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      let url = 'http://api.kbzpay.com/payment/gateway/uat/precreate/';
    // let url = 'https://api.kbzpay.com/payment/gateway/precreate';
      console.log(JSON.stringify(credentials));
      this.http.post(url, JSON.stringify(credentials), {headers: headers}).
      subscribe(res =>{
        resolve(res.json());
      }, (err) =>{
        reject(err);
      });
    });
  }

  postKBZQuearyOrder(credentials){
    return new Promise((resolve, reject) =>{
      let headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      let url = 'http://api.kbzpay.com/payment/gateway/uat/queryorder';
    // let url = 'https://api.kbzpay.com/payment/gateway/queryorder';
      console.log(JSON.stringify(credentials));
      this.http.post(url, JSON.stringify(credentials), {headers: headers}).
      subscribe(res =>{
        resolve(res.json());
      }, (err) =>{
        reject(err);
      });
    });
  }
  
 /*
  postKBZPrecreate(credentials){
    return new Promise((resolve, reject) =>{
      let url = 'http://api.kbzpay.com/payment/gateway/uat/precreate';
    // let url = 'https://api.kbzpay.com/payment/gateway/precreate';
      console.log(JSON.stringify(credentials));
      this.httpnative.post(url, JSON.stringify(credentials), { 'Content-Type': 'application/json' })
      .then( res => resolve(JSON.parse(res.data)))
      });
  }
  */

  postOnePayRequestPayment(credentials){
    return new Promise((resolve, reject) =>{
      let url = 'https://onepayuat.agdbank.com/API/Ver01/Wallet/Wallet_VerifyPhoneNumber';
      this.httpnative.post(url, credentials, {'Content-Type': 'application/x-www-form-urlencoded' })
      .then( res => {
        resolve(JSON.parse(res.data));
      });
    });
  }
  postOnepayMadePayment(credentials){
    return new Promise((resolve, reject) =>{
      console.log(JSON.stringify(credentials));
      let url = 'https://onepayuat.agdbank.com/API/Ver02/Wallet/Wallet_DirectAPIV2';
      this.httpnative.post(url, credentials, {'Content-Type': 'application/x-www-form-urlencoded' })
      .then( res => {
        resolve(JSON.parse(res.data));
      });
    });
  }

  getLocation(){
      let zest = this.loadingMessage('fetchingData')
      zest.present();
      this.geolocation.getCurrentPosition().then((res) => {
        HkApiproviderProvider.location.latitude = ''+res.coords.latitude
        HkApiproviderProvider.location.longitude = ''+res.coords.longitude;
        zest.dismiss();
      }).catch((error) => {
        zest.dismiss();
        console.log('Error getting location', error);
      });
  }

  getDeadImage(){
    return this.caseimagebaseurl;
  }
  getSoldierImage(){
    return this.soldierimagebaseurl;
  }
  getCriminalImage(){
    return this.imageCriminalbaseurl;
  }
  getNotiimage(){
    return this.imageNotibaseurl;
  }
  getbanner(){
    return this.bannerbaseurl;
  }
  getBaseUrl(){
    return this.url;
  }

  static gettoken(){
    return HkApiproviderProvider.token;
  }
  
  apptranslate(tran_text:string){
    let tran_finish='';
    this.translate.get(tran_text).subscribe(t => {
			tran_finish=t;
    });
    return tran_finish;
  }

  loadingMessage(message:string){
   let loader = this.loadingCtrl.create({
       content: this.apptranslate(message),
       duration: 20000
   });
   return loader;
  }

  toastMessage(message:string){
    this.alert_message.cartUpdated = this.apptranslate(message);
    this.toastCtrl.create({
      message: this.alert_message.cartUpdated,
      duration: 1000
    }).present();
  }

  showalertinfo(title,message){
		this.translate.get(title).subscribe(t => {
			this.alert_message.title = t;
		});
		this.translate.get(message).subscribe(t => {
			this.alert_message.message = t;
		});
		let alert = this.alertCtrl.create({
			title:this.alert_message.title,
			subTitle:this.alert_message.message,
			buttons:["OK"]
		});
		alert.present();
  }
  
  promptAlert(title:string,message:string){
    let alert = this.alertCtrl.create({
        title: this.apptranslate(title),
        message: this.apptranslate(message),
        buttons: [
            {
                text: 'Yes',
                handler: () => {
                    alert.dismiss(true);
                    return false;
                }
            }, {
                text: 'No',
                handler: () => {
                    alert.dismiss(false);
                    return false;
                }
            }
        ]
    });
    return alert;
}
exportToExcel(data, filename) {
  const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(data);
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, filename);
  XLSX.writeFile(wb, filename + '.xlsx');
}
}



// WEBPACK FOOTER //
// ./src/providers/hk-apiprovider/hk-apiprovider.ts